import React from "react";
import { DescriptionFieldProps } from "@rjsf/utils";

/**
 * Custom description field component that handles descriptions differently based on ID
 * Root-level descriptions (those with simple IDs like "root") are not rendered
 * Field-level descriptions are rendered normally
 */
const CustomDescriptionField = ({ description, id }: DescriptionFieldProps) => {
    // Return null for empty descriptions or if description doesn't exist
    if (!description) {
        return null;
    }

    // Check if description is a string and is empty
    if (typeof description === 'string' && description.trim() === '') {
        return null;
    }

    // Don't render form-level descriptions (root descriptions)
    // Root descriptions have simple IDs like "root" or "root_description"
    // Field descriptions have more complex IDs with property names
    if (id === "root" || id === "root_description" || id === "root__description") {
        return null;
    }

    // For all other descriptions, render as plain gray text with no background
    return (
        <div className="mt-1">
            <span id={id} className="text-secondary-gray dark:text-neutral-gray-300 text-sm">
                {description}
            </span>
        </div>
    );
};

export default CustomDescriptionField;
